export default "__VITE_ASSET__CU47lp8a__"